// this variable used to support multiple forms with same id on the same page
let internalCounter = 0;
export default (formId) => {
	internalCounter++;
	return (parseInt(formId, 10) * 1000) + (internalCounter * 100);
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/getFormPrefixId.js